export default __webpack_public_path__ + "static/media/chatapp.52cad9d2.png";